import { GET_ALL_FILAS } from './mutation-types'
// import {GET_ALL_OPERADORES_MONITOR} from './mutation-types'
import monitorScreenHttpServices from '../services/monitorScreenHttpServices'

export default {

  listarFilas: async ({ commit }) => {
    try {
      const response = await monitorScreenHttpServices.getFilas()
      commit(GET_ALL_FILAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

}
